import CampaignSlugDetail from "@/Component/Admin/AdminCampaign/CampaignDetail";

const CampaignDetailPage = async ({ params }: { params: Promise<{ slug: string }>; }) => {
    const resolvedParams = await params;
    const slug = resolvedParams.slug;

    return slug && <CampaignSlugDetail slug={slug} />;
};

export default CampaignDetailPage;